<template>
    <div v-bind="attrs" class="flex-item">
        <div v-if="selectedProduct" class="font-weight-bold product-box" :class="{'selected-product':selectedProduct}">
            <ImageLoader
                v-if="selectedProduct.image"
                class="d-block border product-image"
                :src="selectedProduct.image"
                alt=""
            />
            {{ selectedProduct.name }}
        </div>
        <div class="flex-item">
            <b-form-input
                :id="$attrs.id"
                v-model="searchText"
                :placeholder="$t('generator.productSearchPlaceholder')"
                autocomplete="off"
                @input="onChangeText"
            />
            <div v-if="loading" class="d-flex justify-content-center">
                <b-spinner />
            </div>
            <error-message v-else-if="error" v-model="error" />
            <div v-else-if="items.length" class="product-box-wrapper">
                <div v-for="item in items" :key="item.id" class="product-box" @click="onSelectItem(item)">
                    <ImageLoader
                        v-if="item.image"
                        class="d-block border product-image"
                        :src="item.image"
                        alt=""
                    />
                    {{ item.name }}
                </div>
            </div>
            <div v-else-if="response" class="d-flex justify-content-center">
                {{ $t('noResult') }}
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { debounce } from 'lodash';
    import pluginService from '@/services/pluginService';
    import ErrorMessage from '@/components/common/ErrorMessage.vue';
    import ImageLoader from '@/components/common/ImageLoader.vue';

    export default {
        name: 'ProductSearch',
        inheritAttrs: false,
        components: {
            ErrorMessage,
            ImageLoader,
        },
        props: {
            value: {
                type: Object,
            },
        },
        data() {
            return {
                searchText: '',
                loading: false,
                error: null,
                response: null,
            };
        },
        computed: {
            attrs() {
                return { ...this.$attrs, id: undefined };
            },
            items() {
                return this.response || [];
            },
            selectedProduct: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
            ...mapState({
                userId: state => state.auth.user.id,
                currentSpaceId: state => state.space.currentSpaceId,
            }),
        },
        methods: {
            reset() {
                this.loading = false;
                this.error = null;
                this.response = null;
            },
            async searchProducts() {
                this.loading = true;
                await pluginService
                    .searchProducts(this.userId, this.searchText)
                    .then(response => (this.response = response))
                    .catch(error => (this.error = error));
                this.loading = false;
            },
            onChangeText: debounce(function debouncedOnChangeText(text) {
                if (text) {
                    this.searchProducts();
                    this.selectedProduct = undefined;
                } else {
                    this.reset();
                }
            }, 750),
            onSelectItem(product) {
                this.selectedProduct = product;
                this.searchText = '';
                this.reset();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .flex-item {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .product-box-wrapper {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        max-height: 300px;
        overflow-y: auto;
    }

    .product-box {
        display: flex;
        align-items: center;

        &:not(.selected-product) {
            padding: 1rem;
            cursor: pointer;

            &:hover {
                background: $gray-200;
            }
        }
    }

    .product-image {
        margin-right: 15px;
        max-width: 100px;
        max-height: 60px;

        &.image-error,
        &.image-loader {
            width: 40px;
            height: 40px;
            background-size: 90%;
        }
    }
</style>
